import { AnalysisConfig } from "~/_legacy/types/analysis";
import { CameraMemoResponse, CountingLineResponse, IntervalZoneResponse } from "~/_legacy/types/api";
import {
  convertCameraMemoResponseToCameraMemo,
  convertCountingLineResponseToCountingLine,
  convertIntervalZoneResponseToIntervalZone,
} from "~/_legacy/utils/convert";
import axiosInstance from "./axios-instance";

const createApiUrl = (branchUid: string) => `branches/${branchUid}/analysis-settings/`;

export const fetchAnalysisConfigs = async ({
  branchUid,
  branchVersionId,
}: {
  branchUid: string;
  branchVersionId?: number;
}) => {
  const url = createApiUrl(branchUid);
  const { data } = await axiosInstance.get<
    {
      pseudo_camera_orientation_id: number;
      analyzed_id?: string;
      floor_plan_id?: number;
      preview_img_url?: string;
      pseudo_camera_id: number;
      counting_lines: CountingLineResponse[];
      interval_zones: IntervalZoneResponse[];
      comments: CameraMemoResponse[];
    }[]
  >(url, {
    params: {
      version: branchVersionId,
    },
  });

  const converted: AnalysisConfig[] = data.map((item) => ({
    cameraId: item.pseudo_camera_orientation_id,
    analysisNumber: item.analyzed_id ?? null,
    floorPlanId: item.floor_plan_id ?? null,
    previewImageUrl: item.preview_img_url,
    pseudoCameraId: item.pseudo_camera_id,
    countingLines: item.counting_lines.map(convertCountingLineResponseToCountingLine),
    intervalZones: item.interval_zones.map(convertIntervalZoneResponseToIntervalZone),
    memos: item.comments.map(convertCameraMemoResponseToCameraMemo),
  }));

  return converted;
};
